/**
 * PERFORMANCE OPTIMIZATION:
 * jQuery is now loaded with defer, so we need to ensure it's ready before using it.
 * This wrapper ensures the script waits for jQuery to be available.
 */
var key = "xVkGI3YC794WD7O";

function VerifiedEmailControl(email) {
  const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if(!email || !EMAIL_REGEX.test(email)){
    $('#customer_login #email_address').parent().next().css('display', 'block')
    $('#customer_login #email_address').parent().next().next().css('display', 'block')
    $('#customer_login #email_address').parent().next().next().next().css('display', 'flex')
    return;
  }
  $.ajax({
    url: "/apps/apibridge/integration/path/cm5gmuxs30004vd4r4tg0pcln?email=" + email,
    async: true,
    method: 'POST',
    cache: true,
    success: function(result){
        const response = getJsonFromApiBridge(result);
        if(response?.data?.state === 'DISABLED' || response?.data?.state === 'INVITED'){
          window.dispatchEvent(new CustomEvent('open-activation-modal', { 
            detail: { email: email } 
          }));
          $('#customer_login #email_address').parent().next().css('display', 'none')
          $('#customer_login #email_address').parent().next().next().css('display', 'none')
          $('#customer_login #email_address').parent().next().next().next().css('display', 'none')
        } else {
          $('#customer_login #email_address').parent().next().css('display', 'block')
          $('#customer_login #email_address').parent().next().next().css('display', 'block')
          $('#customer_login #email_address').parent().next().next().next().css('display', 'flex')
        }
    },
    error: function(err){
    }
  });
}

function SendMailActivation(email) {
  window.dispatchEvent(new CustomEvent('send-activation-email', { 
    detail: { email: email } 
  }));
  
  $.ajax({
    url: "/apps/apibridge/integration/path/cm5go48k10009vd4r0n1qs82v?email=" + email,
    async: true,
    cache: true,
    method: 'POST',
    success: function(result){
      const response = getJsonFromApiBridge(result);
      if(response){
        window.dispatchEvent(new CustomEvent('activation-email-success', { 
          detail: { email: email } 
        }));
      }else{
        window.dispatchEvent(new CustomEvent('activation-email-error'));
      }
    },
    error: function(err){
      window.dispatchEvent(new CustomEvent('activation-email-error'));
    }
  });
}

function getJsonFromApiBridge(response){
  if(response.success && response.data.body){
    return JSON.parse(response.data.body);
  }
  return null;
}

(function() {
  function initCustomScripts() {
    // Original code starts here
    $(function(){
      $('#customer_login #email_address').change(function(){
        VerifiedEmailControl($(this).val());
      });

      $(document).on('click', '.send-activation-mail', function(){
        SendMailActivation($('#customer_login #email_address').val());
      });
      
      $('[name="options[Beden]"]').click(function(){
        $('.get-inventory-info').attr('data-sku', $(this).data('sku'));
      });
      

      $(document).on('click', '.mss-link', function(){
        mssForm();
      });

      $(document).on('click', '.ob-link', function(){
        obForm();
      });

      if($('#mss-form').length > 0){
        if(!GetUrlParameter('param')){
      var form = $('#mss-form').html();
      var arr = form.match(/\{.+?\}/g);
      $.each(arr, function(i, v){
          form = form.replace(v, '........');
      });
      $('#mss-form').html(form); 
    }
  }

  if($('#ob-form').length > 0){
    if(!GetUrlParameter('param')){
      var form = $('#ob-form').html();
      var arr = form.match(/\{.+?\}/g);
      $.each(arr, function(i, v){
          form = form.replace(v, '........');
      });
      $('#ob-form').html(form); 
    }
  }

  $('.show-only-app').each(function(){
    if(mobileDevice()){
      $(this).addClass('hidden');
    }else{
      $(this).addClass('hidden');
    }
  });

  $('.hide-only-app').each(function(){
    if(mobileDevice()){
      $(this).addClass('hidden');
    }else{
      $(this).addClass('hidden');
    }
  });

  $('#checkout_shipping_address_phone, #checkout_billing_address_phone').keyup(function(){
    var t = $(this);
    var v = t.val();
    var l = v.startsWith('0') || v.startsWith('05') ? (v.indexOf(' ') === -1 ? 11 : 14) : (v.startsWith('5') ? (v.indexOf(' ') === -1 ? 10 : 13) : 0);
    if(!v.startsWith('0') && !v.startsWith('05') && !v.startsWith('5')){
        t.val('');
    }else if(t.val().length > l){
        t.val(v.substring(0, l));
    }
  });
  
  if(Shopify?.Checkout?.step === 'contact_information' || Shopify?.Checkout?.step === 'payment_method'){
    checkoutControl();
    //setInterval(function(){
    //  if(($('input#checkout_shipping_address_address2').length > 0 && $('[name="checkout[id]"]:checked').val() == "delivery-shipping") || 
    //      ($('.shipping-type-pickup').length === 0 && $('[name="checkout[id]"]:checked').val() == "delivery-pickup") ||
    //      (($('input#checkout_billing_address_address2').length > 0 && $('[name="checkout[different_billing_address]"]:checked').val() == "true")) || $('.policycheckbox').length === 0){
    //    checkoutControl();
    //  }
    //}, 1000);
    if(Shopify.Checkout?.step === 'contact_information'){
      window.addEventListener('DOMContentLoaded', function() {
        $('.edit_checkout').removeAttr("novalidate");
        hideOriginalCheckoutPickupSection();
        createCheckoutPickupSection();
      });
    }else if(Shopify.Checkout?.step === 'payment_method'){
      billingTypeChange();
    }
  }
});

function checkoutContinueControl(){
  var os = $('#order-summary');
  var subTotal = os.find('.total-line--subtotal .total-line__price span').attr('data-checkout-subtotal-price-target');
  var flag = false;
  os.find('.product-table tr.product').each(function(){
    var itemPrice = $(this).find('td.product__price span').html();
    if(itemPrice == '₺0' || itemPrice == '₺0,00' || itemPrice == '₺0.00'){
      flag = true;
    }
  });

  if(subTotal == 0 || flag){
    $('#continue_button').remove();
  }
}

function checkoutControl() {
  
  if(Shopify?.Checkout?.step === 'contact_information' || Shopify?.Checkout?.step === 'payment_method'){
    checkoutContinueControl();
    if(Shopify.Checkout?.step === 'contact_information'){
      
      if($('#checkout_shipping_address_id').length > 0){
          var selectedAddressJson = $('#checkout_shipping_address_id').find(':selected').data('properties');
          SetShipmentAddress(selectedAddressJson);
      }

      $('.sms-marketing-fieldset').addClass('hidden');
  
      setTimeout(function(){
        shippingTypeChange();
      }, 500);
      
      ChangeShippingAddressFields();
      hideOriginalCheckoutPickupSection();
      createCheckoutPickupSection();
      
      $(document).on('change', '[name="checkout[id]"]', function(){
        shippingTypeChange();
      });

      var selectedCity = '';
      $(document).on('change', '[name="checkout[shipping_address][city]"]', function(){
        var city = $(this).val();
        if(selectedCity !== city){
          localStorage.setItem('checkout-shipping_address-city', city);
          setDistricts($('[name="checkout[shipping_address][address2]"]'), city);
          selectedCity = city;
        }
      });
      
      $(document).on('change', '[name="checkout[shipping_address][address2]"]', function(){
        var district = $(this).val();
        if(district !== undefined && district !== ''){
          localStorage.setItem('checkout-shipping_address-district', district);
        }
      });
      
      $(document).on('change', '[name="checkout[attributes][city]"]', function(){
        var city = $(this).val();
        if(city !== undefined && city !== ''){
          localStorage.setItem('checkout-attributes-city', city);
          setDistricts($('[name="checkout[attributes][address2]"]'), city);
        }
      });
      
      $(document).on('change', '[name="checkout[attributes][store]"]', function(){
        var code = $(this).val();
        if(code !== undefined && code !== ''){
          var value = $('[name="checkout[attributes][store]"] option[value=' + code + ']').text();
          if(value === '')
            value = $('[name="checkout[attributes][store]"]').val();
          localStorage.setItem('checkout-attributes-store', value);
          localStorage.setItem('checkout-attributes-store-code', code);
        }
      });
      
      $(document).on('change', '#checkout_shipping_address_id', function(){
        if($(this).val() === ''){
          SetShipmentAddress(null);
        }else{
          var selectedAddressJson = $(this).find(':selected').data('properties');
          SetShipmentAddress(selectedAddressJson);
        }
      });
      
      $('[data-customer-information-form="true"]').submit(function(){
        localStorage.setItem('checkout', enc(JSON.stringify($('form').serializeArray())));
      });
      
    }
    else if(Shopify.Checkout?.step === 'payment_method'){
      
      if($('#checkout_billing_address_id').length > 0){
          var selectedAddressJson = $('#checkout_billing_address_id').find(':selected').data('properties');
          SetPaymentAddress(selectedAddressJson);
      }

      var shippingType = $('.address.address--tight').length > 0 ? 'cargo' : 'clickandcollect';
      localStorage.setItem('checkout-shippingType', shippingType);
      
      ShippingConsentForm();
      ChangePaymentAddressFields();
      billingTypeChange();

      $('[data-payment-form]').submit(function(){
        if($('#checkout_attributes_tc_id').val() === ''){
          $('#checkout_attributes_tc_id').attr('disabled', 'disabled');
        }
        if($('#checkout_attributes_tax_id').val() === ''){
          $('#checkout_attributes_tax_id').attr('disabled', 'disabled');
        }
        if($('#checkout_attributes_tax_office').val() === ''){
          $('#checkout_attributes_tax_office').attr('disabled', 'disabled');
        }
      });
      
      $(document).on('change', '[name="checkout[different_billing_address]"]', function(){
        localStorage.setItem('checkout-billing_address-different', $('[name="checkout[different_billing_address]"]:checked').val() === 'true');
        billingTypeChange();
      });

      var selectedCity = '';
      $(document).on('change', '[name="checkout[billing_address][city]"]', function(){
        var city = $(this).val();
        if(selectedCity !== city){
          localStorage.setItem('checkout-billing_address-city', city);
          setDistricts($('[name="checkout[billing_address][address2]"]'), city);
          selectedCity = city;
        }
      });
      
      $(document).on('change', '[name="checkout[billing_address][address2]"]', function(){
        var district = $(this).val();
        if(district !== undefined && district !== ''){
          localStorage.setItem('checkout-billing_address-district', district);
        }
      });
      
      var generatedEl = generateCustomInputElement('checkout_attributes_tc_id', 'checkout[attributes][tc_id]', 'TCKN (Opsiyonel)', 'TCKN (Opsiyonel)');
      appendCustomElement($('#checkout_billing_address_last_name').parents('.field'), generatedEl);
      var generatedEl = generateCustomInputElement('checkout_attributes_tax_id', 'checkout[attributes][tax_id]', 'Vergi Numarası (Opsiyonel)', 'Vergi Numarası (Opsiyonel)');
      appendCustomElement($('#checkout_billing_address_last_name').parents('.field'), generatedEl);
      var generatedEl = generateCustomInputElement('checkout_attributes_tax_office', 'checkout[attributes][tax_office]', 'Vergi Dairesi (Opsiyonel)', 'Vergi Dairesi (Opsiyonel)');
      appendCustomElement($('#checkout_billing_address_last_name').parents('.field'), generatedEl);
      var generatedEl = generateCustomInputElement('checkout_attributes_company_name', 'checkout[attributes][company_name]', 'Şirket Adı (Opsiyonel)', 'Şirket Adı (Opsiyonel)');
      appendCustomElement($('#checkout_billing_address_last_name').parents('.field'), generatedEl);
      
      var cityToCheck = localStorage.getItem('checkout-attributes-city');
      var storeCodeToCheck = localStorage.getItem('checkout-attributes-store-code');
      if (cityToCheck && cityToCheck !== '' && storeCodeToCheck && storeCodeToCheck !== '') {
        appendCustomElement($('.step__footer'), "<input type='hidden' name='checkout[attributes][city]' value='" + localStorage.getItem('checkout-attributes-city') + "' />");
        appendCustomElement($('.step__footer'), "<input type='hidden' name='checkout[attributes][store]' value='" + localStorage.getItem('checkout-attributes-store-code') + "' />");
      }
      
      if(shippingType === 'clickandcollect') {
        openTaxFields(true);
        var city = localStorage.getItem('checkout-attributes-city');
        var store = localStorage.getItem('checkout-attributes-store');
        $('[data-step="payment_method"] .review-block__content strong').html(store + '/' + city);
        GetWarehouse(localStorage.getItem('checkout-attributes-store-code'), $('[data-step="payment_method"] .review-block__content p.small-text'));
      }
      
      $(document).on('change', '#checkout_billing_address_id', function(){
        if($(this).val() === ''){
          SetPaymentAddress(null);
        }else{
          var selectedAddressJson = $(this).find(':selected').data('properties');
          SetPaymentAddress(selectedAddressJson);
        }
      });
    }
  }

}

function SetShipmentAddress(data){
  $('[name="checkout[shipping_address][first_name]"]').val(data?.first_name ?? '');
  $('[name="checkout[shipping_address][last_name]"]').val(data?.last_name ?? '');
  $('[name="checkout[shipping_address][company]"]').val(data?.company ?? '');
  $('[name="checkout[shipping_address][address1]"]').val(data?.address1 ?? '');
  $('[name="checkout[shipping_address][zip]"]').val(data?.zip ?? '');
  $('[name="checkout[shipping_address][phone]"]').val(data?.phone ?? '');

  var city = data?.city ?? '';
  $('[name="checkout[shipping_address][city]"] option[value="' + city + '"]').prop('selected', true);
  
  var district = data?.address2 ?? '';
  setDistricts($('[name="checkout[shipping_address][address2]"]'), city, district);
  localStorage.setItem('checkout-shipping_address-city', city);
  localStorage.setItem('checkout-shipping_address-district', district);
}

function SetPaymentAddress(data){
  $('[name="checkout[billing_address][first_name]"]').val(data?.first_name ?? '');
  $('[name="checkout[billing_address][last_name]"]').val(data?.last_name ?? '');
  $('[name="checkout[billing_address][company]"]').val(data?.company ?? '');
  $('[name="checkout[billing_address][address1]"]').val(data?.address1 ?? '');
  $('[name="checkout[billing_address][zip]"]').val(data?.zip ?? '');
  $('[name="checkout[billing_address][phone]"]').val(data?.phone ?? '');

  var city = data?.city ?? '';
  $('[name="checkout[billing_address][city]"] option[value="' + city + '"]').prop('selected', true);
  
  var district = data?.address2 ?? '';
  setDistricts($('[name="checkout[billing_address][address2]"]'), city, district);
  localStorage.setItem('checkout-billing_address-city', city);
  localStorage.setItem('checkout-billing_address-district', district);
}

function ShippingConsentForm(){
   if (Shopify.Checkout?.step === 'contact_information') {
     
   } else if (Shopify.Checkout?.step == 'payment_method') {
     if($('.policycheckbox').length === 0){
        var policycheckbox = 
          '<div class="field field--show-floating-label policycheckbox" style="float: none; margin-left: -6px; margin-top: 2px;">'+
          '<div class="checkbox-wrapper">'+
          '<div class="checkbox__input">'+
          '<input class="input-checkbox" type="checkbox" required="required" id="kvkk_checkbox" name="kvkk_checkbox">'+
          '</div>'+
          '<label class="checkbox__label" for="kvkk_checkbox"><a href="javascript:;" class="ob-link">Ön Bilgilendirme Koşullarını</a> ve <a href="javascript:;" class="mss-link">Mesafeli Satış Sözleşmesini</a> okudum ve kabul ediyorum.</label>'+
          '</div>'+
          '</div>';
        $('.step__footer').before(policycheckbox);
      }
     if($('.kvkkcheckbox').length === 0){
      var kvkkcheckbox = 
        '<br><div class="field field--show-floating-label kvkkcheckbox" style="float: none;margin-left: -6px;margin-top: -18px;">'+
        '<div class="checkbox-wrapper" style="cursor:auto;">'+
        
        '<label class="checkbox__label" style="cursor:auto;">Kişisel verileriniz, <a href="/pages/kisisel-veriler-ile-i̇lgili-aydinlatma-metni" target="_blank"><b>Derimod Kişisel Veriler ile İlgili Aydınlatma Metni</b></a> uyarınca işlenecektir.</label>'+
        '</div>'+
        '</div>';
      
      $('.step__footer').before(kvkkcheckbox);
     }
    }
}

function openTaxFields(open){
  if(open){
    $('#checkout_attributes_tc_id').removeAttr('disabled');
    $('#checkout_attributes_tax_id').removeAttr('disabled');
    $('#checkout_attributes_tax_office').removeAttr('disabled');
    $('#checkout_attributes_company_name').removeAttr('disabled');
  }else {
    $('#checkout_attributes_tc_id').attr('disabled');
    $('#checkout_attributes_tax_id').attr('disabled');
    $('#checkout_attributes_tax_office').attr('disabled');
    $('#checkout_attributes_company_name').attr('disabled');
  }
}

function shippingTypeChange(){
  if(Shopify.Checkout?.step == 'contact_information'){
    //var shippingType = $('[name="checkout[id]:checked"]').val() === 'delivery-shipping' ? 'cargo' : 'clickandcollect';
    //localStorage.setItem('checkout-shippingType', shippingType);
    var elements = document.querySelectorAll('.field--show-floating-label');
    elements.forEach(function(element) {
      var label = element.querySelector('.checkbox__label');
      if (label && label.textContent.trim() === 'Haberler ve teklifler hakkında bana kısa mesaj gönder') {
        element.style.display = 'none';
      }
    });
    //if(shippingType === 'cargo'){
    if($('[name="checkout[id]"]:checked').val() === 'delivery-shipping'){
      $('[data-delivery-shipping-info]').removeClass('hidden-if-js').css('display', 'block');
      $('.shipping-type-pickup').addClass('hidden-if-js').css('display', 'none');
      $('[name="checkout[shipping_address][city]"]').removeAttr('disabled').attr('required', 'required');
      $('[name="checkout[shipping_address][address2]"]').removeAttr('disabled').attr('required', 'required');
      $('[name="checkout[attributes][city]"]').attr('disabled', 'disabled').removeAttr('required');
      $('[name="checkout[attributes][store]"]').attr('disabled', 'disabled').removeAttr('required');
      $('input[name="checkout[shipping_address][city]"]').remove();
      $('input[name="checkout[shipping_address][address2]"]').remove();
    
      localStorage.removeItem('checkout-attributes-city');
      localStorage.removeItem('checkout-attributes-store');
      localStorage.removeItem('checkout-attributes-store-code');
      var selectedShippingCity = localStorage.getItem('checkout-shipping_address-city');
      if(selectedShippingCity !== ''){
        $('[name="checkout[shipping_address][city]"]').val(selectedShippingCity);
        var selectedShippingDistrict = localStorage.getItem('checkout-shipping_address-district');
        setDistricts($('[name="checkout[shipping_address][address2]"]'), selectedShippingCity, selectedShippingDistrict);
      }
      if($('#checkout_shipping_address_id').length > 0){
          var selectedAddressJson = $('#checkout_shipping_address_id').find(':selected').data('properties');
          SetShipmentAddress(selectedAddressJson);
      }

    }else{
        $('[data-delivery-shipping-info]').addClass('hidden-if-js').css('display', 'none');
        $('.shipping-type-pickup').removeClass('hidden-if-js').css('display', 'block');
        $('[name="checkout[shipping_address][city]"]').attr('disabled', 'disabled').removeAttr('required');
        $('[name="checkout[shipping_address][address2]"]').attr('disabled', 'disabled').removeAttr('required');
        $('[name="checkout[attributes][city]"]').removeAttr('disabled').attr('required', 'required');
        $('[name="checkout[attributes][store]"]').removeAttr('disabled').attr('required', 'required');

        localStorage.removeItem('checkout-shipping_address-city');
        localStorage.removeItem('checkout-shipping_address-district');
        var selectedPickupCity = localStorage.getItem('checkout-attributes-city');
        if(selectedPickupCity !== ''){
          $('[name="checkout[attributes][city]"]').val(selectedPickupCity);
          var selectedPickupStoreCode = localStorage.getItem('checkout-attributes-store-code');
          setStores($('[name="checkout[attributes][store]"]'), selectedPickupCity, selectedPickupStoreCode);
        }
    }
  }
}

function billingTypeChange(){
  if(Shopify.Checkout?.step == 'payment_method'){
    var differentBillingAddress = localStorage.getItem('checkout-billing_address-different');
    var shippingType = localStorage.getItem('checkout-shippingType');
    if(differentBillingAddress !== null){
      $('[name="checkout[different_billing_address]"][value="' + differentBillingAddress + '"]').parent().parent().find('label').click();
    }
    if($('[name="checkout[different_billing_address]"]:checked').val() === 'true' || shippingType === 'clickandcollect'){
      $('#checkout_billing_address_city').attr('required', 'required');
      $('#checkout_billing_address_address1').attr('required', 'required');
      $('#checkout_billing_address_address2').attr('required', 'required');
      openTaxFields(true);
      localStorage.setItem('checkout-billing_address-different', true);
      var selectedBillingCity = localStorage.getItem('checkout-billing_address-city');
      var selectedBillingDistrict = localStorage.getItem('checkout-billing_address-district');
      if(selectedBillingCity !== ''){
        $('[name="checkout[billing_address][city]"]').val(selectedBillingCity);
        setDistricts($('[name="checkout[billing_address][address2]"]'), selectedBillingCity, selectedBillingDistrict);
      }
    }else{
      $('#checkout_billing_address_city').removeAttr('required');
      $('#checkout_billing_address_address1').removeAttr('required');
      $('#checkout_billing_address_address2').removeAttr('required');
      openTaxFields(false);
      localStorage.setItem('checkout-billing_address-different', false);
      localStorage.removeItem('checkout-billing_address-city');
      localStorage.removeItem('checkout-billing_address-district');
    }
  }
  if($('#checkout_billing_address_id').length > 0){
      var selectedAddressJson = $('#checkout_billing_address_id').find(':selected').data('properties');
      SetPaymentAddress(selectedAddressJson);
  }
}

function generateCustomInputElement(id, name, title, placeHolder){
  if ($('#' + id).length > 0) 
    return null;
  
  return  '<div data-autocomplete-field-container="true" class="field field--optional">' +
          '   <div class="field__input-wrapper"><label class="field__label field__label--visible" for="' + id + '">' + title + '</label>' +
          '     <input placeholder="' + placeHolder + '" class="field__input" size="30" type="text" name="' + name + '" id="' + id + '" value="" disabled />' +
          '   </div>' +
          '</div>';
}

function generateCustomSelectElement(id, name, title, options, selected){
  if ($('#' + id).length > 0) 
    return null;
  
  var option = '<option value="">Seçiniz...</option>';
  if(options !== null){
    $.each(options, function(i ,v){
      option += '<option value="' + v.value + '">' + v.name + '</option>';
    }); 
  }
  return '<div class="field field--half field--optional field--show-floating-label">' +
         '   <div class="field__input-wrapper"><label class="field__label field__label--visible" for="' + id + '">' + title + '</label>' +
         '     <select class="field__input" name="' + name + '" id="' + id + '">' + option + '</select>' +
         '   </div>' +
         '</div>';
}

function appendCustomElement(appendEl, el){
  if(el !== null){
    $(appendEl).after(el);
  }
}

function GetWarehouse(code, el){
  var settings = {
    "url": "/apps/apibridge/integration/path/cm5gocuz7000evd4r09gvpvhu?code=" + code,
    "method": "POST",
  };
  
  $.ajax(settings).done(function (response) {
    const result = getJsonFromApiBridge(response);
    $(el).html(result.data.address);
    return result;
  });
}

function VerifiedEmailControl(email) {
  const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if(!email || !EMAIL_REGEX.test(email)){
    $('#customer_login #email_address').parent().next().css('display', 'block')
    $('#customer_login #email_address').parent().next().next().css('display', 'block')
    $('#customer_login #email_address').parent().next().next().next().css('display', 'flex')
    return;
  }
  $.ajax({
    url: "/apps/apibridge/integration/path/cm5gmuxs30004vd4r4tg0pcln?email=" + email,
    async: true,
    method: 'POST',
    cache: true,
    success: function(result){
        const response = getJsonFromApiBridge(result);
        if(response?.data?.state === 'DISABLED' || response?.data?.state === 'INVITED'){
          window.dispatchEvent(new CustomEvent('open-activation-modal', { 
            detail: { email: email } 
          }));
          $('#customer_login #email_address').parent().next().css('display', 'none')
          $('#customer_login #email_address').parent().next().next().css('display', 'none')
          $('#customer_login #email_address').parent().next().next().next().css('display', 'none')
        } else {
          $('#customer_login #email_address').parent().next().css('display', 'block')
          $('#customer_login #email_address').parent().next().next().css('display', 'block')
          $('#customer_login #email_address').parent().next().next().next().css('display', 'flex')
        }
    },
    error: function(err){
    }
  });
}

function SendMailActivation(email) {
  window.dispatchEvent(new CustomEvent('send-activation-email', { 
    detail: { email: email } 
  }));
  
  $.ajax({
    url: "/apps/apibridge/integration/path/cm5go48k10009vd4r0n1qs82v?email=" + email,
    async: true,
    cache: true,
    method: 'POST',
    success: function(result){
      const response = getJsonFromApiBridge(result);
      if(response){
        window.dispatchEvent(new CustomEvent('activation-email-success', { 
          detail: { email: email } 
        }));
      }else{
        window.dispatchEvent(new CustomEvent('activation-email-error'));
      }
    },
    error: function(err){
      window.dispatchEvent(new CustomEvent('activation-email-error'));
    }
  });
}


/* CHECKOUT FUNCTIONS */
function ChangeShippingAddressFields(){
  $('[data-address-field="address2"]').remove();
  $('[data-address-field="city"]').remove();
  $('[data-address-field="phone"]').addClass('field--half');
  if($('#checkout_shipping_address_id').length > 0){
    $('#checkout_shipping_address_id').removeAttr('data-address-selector');
  }
  
  var cities = []; 
  $.each(cityjson, function(v){
    cities.push({name: v, value: v });
  });
  if($('#checkout_shipping_address_city').length === 0){
    var generatedEl = generateCustomSelectElement("checkout_shipping_address_city", "checkout[shipping_address][city]", "Şehir" , cities, null);
    appendCustomElement($('#checkout_shipping_address_address1').parents('.field'), generatedEl);
  }
  if($('#checkout_shipping_address_address2').length === 0){
    var generatedEl = generateCustomSelectElement("checkout_shipping_address_address2", "checkout[shipping_address][address2]", "İlçe", null, null);
    appendCustomElement($('#checkout_shipping_address_city').parents('.field'), generatedEl);
  }
}

function ChangePaymentAddressFields(){
  $('[data-address-field="address2"]').remove();
  $('[data-address-field="city"]').remove();
  $('[data-address-field="phone"]').addClass('field--half');
  if($('#checkout_billing_address_id').length > 0){
    $('#checkout_billing_address_id').removeAttr('data-address-selector');
  }
  
  var cities = []; 
  $.each(cityjson, function(v){
    cities.push({name: v, value: v });
  });
  if($('#checkout_billing_address_city').length === 0){
    var generatedEl = generateCustomSelectElement("checkout_billing_address_city", "checkout[billing_address][city]", "Şehir" , cities, null);
    appendCustomElement($('#checkout_billing_address_address1').parents('.field'), generatedEl);
    
  }
  if($('#checkout_billing_address_address2').length === 0){
    var generatedEl = generateCustomSelectElement("checkout_billing_address_address2", "checkout[billing_address][address2]", "İlçe", null, null);
    appendCustomElement($('#checkout_billing_address_city').parents('.field'), generatedEl);
    $('#checkout_billing_address_address2').attr('required', 'required');
  }
}

function hideOriginalCheckoutPickupSection() {
  const originalSection = $('.section[data-delivery-pickup-info=""]');
  if (originalSection) {
    originalSection.css('display', 'none');
  }
}

function createCityDropdown() {
  const citySelect = document.createElement('select');
  citySelect.className = 'content-box__row';
  citySelect.name = 'checkout[attributes][city]';
  citySelect.style.border = '1px solid #d9d9d9';
  citySelect.style.borderBottom = '0px';
  citySelect.required = true;
  citySelect.disabled = true;

  const defaultOption = document.createElement('option');
  defaultOption.textContent = 'Şehir Seçin';
  defaultOption.value = '';
  citySelect.appendChild(defaultOption);

  for (const city of cities) {
    const option = document.createElement('option');
    option.value = city;
    option.textContent = city;
    citySelect.appendChild(option);
  }

  return citySelect;
}

function populateStoreDropdown(selectedCity, storeSelect) {

  storeSelect.innerHTML = '';

  const storeIds = storesByCity[selectedCity] || [];
  
  const option = document.createElement('option');
  option.textContent = 'Seçiniz...';
  option.value = '';
  option.dataset.sehir = selectedCity;
  option.dataset.magaza = 'Seçiniz...';
  option.name = 'attributes[store]';
  option.form = 'cart';
  storeSelect.appendChild(option);
  for (const storeId of storeIds) {
    const storeName = storeMappings[storeId];
    if (storeName) {
      const option = document.createElement('option');
      option.value = storeId;
      option.textContent = storeName;
      option.dataset.sehir = selectedCity;
      option.dataset.magaza = storeName;
      option.name = 'attributes[store]';
      option.form = 'cart';
      storeSelect.appendChild(option);
    }
  }
}

function createCheckoutPickupSection() {
  if($('.shipping-type-pickup').length === 0){
    const pickupSection = document.createElement('div');
    pickupSection.className = 'section shipping-type-pickup';
  
    const header = document.createElement('h2');
    header.className = 'section__title';
    header.textContent = 'Şehir ve Mağaza Seçin';
    pickupSection.appendChild(header);
  
    const content = document.createElement('div');
    content.className = 'content-box__row';
    content.style.padding = '0';
    content.style.paddingTop = '1rem';
  
    const cityDropdown = createCityDropdown();
    content.appendChild(cityDropdown);
  
    const storeSelect = document.createElement('select');
    storeSelect.className = 'content-box__row';
    storeSelect.name = 'checkout[attributes][store]';
    storeSelect.style.border = '1px solid #d9d9d9';
  
    const defaultOption = document.createElement('option');
    defaultOption.textContent = 'Mağaza Seçin';
    defaultOption.value = '';
    storeSelect.appendChild(defaultOption);
  
    content.appendChild(storeSelect);
  
    cityDropdown.addEventListener('change', function() {
      const selectedCity = cityDropdown.value;
      populateStoreDropdown(selectedCity, storeSelect);
    });
    pickupSection.appendChild(content);
  
    const originalSectionParent = document.querySelector('.section[data-delivery-pickup-info=""]') ?. parentElement;
    if (originalSectionParent !== undefined) {
      originalSectionParent.insertBefore(pickupSection, document.querySelector('.section[data-delivery-pickup-info=""]'));
    }
  }
}

function setDistricts(selectEl, city, selectedDistrict){
  var districts = [];
  $.each(cityjson, function(i, v){
      if(i === city){
        $.each(v, function(a, b){
          districts.push(b);
        });
      }
  });
  selectEl.empty().append('<option value="">Seçiniz...</option>');
  $.each(districts, function(i, v) {
    if(selectedDistrict === v)
      selectEl.append('<option value="' + v + '" selected="selected">' + v + '</option>');
    else
      selectEl.append('<option value="' + v + '">' + v + '</option>');
  });
}

function setStores(selectEl, city, selectedStore){
  var stores = [];
  $.each(storesByCity, function(i, v){
      if(i === city){
        $.each(v, function(a, b){
          stores.push({name: storeMappings[b], value: b});
        });
      }
  });
  selectEl.empty().append('<option value="">Seçiniz...</option>');
  $.each(stores, function(i, v) {
    if(selectedStore === v.value)
      selectEl.append('<option value="' + v.value + '" selected="selected">' + v.name + '</option>');
    else
      selectEl.append('<option value="' + v.value + '">' + v.name + '</option>');
  });
}

function mssForm(){
  $.ajax({
      url: 'https://www.derimod.com.tr/pages/mesafeli-satis-sozlesmesi?param',
      cache: true,
      async: true,
      beforeSend: function () { HC_Loading(true); },
      complete: function () { HC_Loading(false); },
      success: function (response) {
        var total = 0;
        var discount = 0;
        var subTotal = 0;
        var c = $.parseJSON(dec(localStorage.getItem('checkout')));
        var form = response;
        form = $(form).find('#mss-form').html()
          .replaceAll('{customerName}', getFromArr(c, 'checkout[shipping_address][first_name]') + ' ' + getFromArr(c, 'checkout[shipping_address][last_name]'))
          .replaceAll('{customerAddress}', getFromArr(c, 'checkout[shipping_address][address1]') + ' ' + getFromArr(c, 'checkout[shipping_address][city]') + ' ' + getFromArr(c, 'checkout[shipping_address][address2]'))
          .replaceAll('{email}', getFromArr(c, 'checkout[email]'))
          .replaceAll('{phone}', getFromArr(c, 'checkout[shipping_address][phone]'))
          .replaceAll('{fax}', '')
          .replaceAll('{cargoPrice}', $('.total-line.total-line--shipping td span').html())
          .replaceAll('{discountPrice}', '')
          .replaceAll('{totalPrice}', $('.total-line__price.payment-due span:eq(1)').html())
          .replaceAll('{paymentType}', '')
          .replaceAll('{shipmentAddress}', getFromArr(c, 'checkout[shipping_address][address1]') + ' ' + getFromArr(c, 'checkout[shipping_address][city]') + ' ' + getFromArr(c, 'checkout[shipping_address][address2]'))
          .replaceAll('{shipmentCustomerName}', getFromArr(c, 'checkout[shipping_address][first_name]') + ' ' + getFromArr(c, 'checkout[shipping_address][last_name]'))
          .replaceAll('{billingAddress}', getLocalStorage('checkout-billing_address-different') === false ? (getFromArr(c, 'checkout[shipping_address][address1]') + ' ' + getFromArr(c, 'checkout[shipping_address][city]') + ' ' + getFromArr(c, 'checkout[shipping_address][address2]')) : ($('#checkout_billing_address_address1').val() + ' ' + $('#checkout_billing_address_city').val() + ' ' + $('#checkout_billing_address_address2').val()))
          .replaceAll('{date}', new Date().getDate() + '.' + (new Date().getMonth() + 1) + '.' + new Date().getFullYear());
        
        if (form !== '') {
            var title = '<div class="hc-product-info-title"><h2>Mesafeli Satış Sözleşmesi</h2></div>';
            var body = '<div class="hc-product-info-body" style="padding: 20px;overflow:scroll; max-height:600px;">' + form + '<div class="hc-clear"></div></div>';
            var close = '<div class="hc-product-info-close"><span onclick="HC_CloseInventoryInfo()">X</span></div>';
            var area = '<div class="hc-product-info-area hc-form-info">' + close + title + body + '</div>';
            var html = '<div class="hc-product-info-bg">' + area + '</div>';
            $('body').prepend(html);
          
            $('.order-summary__section__content table.product-table tbody[data-order-summary-section="line-items"] tr.product').each(function(i, v){
                var orderItem = $('.mss-form-order-item').eq(0).clone();
                orderItem.find('td:eq(0)').html($(v).find('.product__description span:eq(0)').html() + ' ' + $(v).find('.product__description span:eq(1)').html());
                orderItem.find('td:eq(1)').html($(v).find('.product__quantity span:eq(0)').html());
                orderItem.find('td:eq(2)').html($(v).find('.product__price span:eq(0)').html());
                orderItem.find('td:eq(3)').html($(v).find('.product__price span:eq(0)').html());
                $('.mss-form-order-item').eq(i).after(orderItem);
            });
            $('.mss-form-order-item').eq(0).remove();
        }
      },
      error: function () { },
  });
}

function obForm(){
  $.ajax({
      url: 'https://www.derimod.com.tr/pages/on-bilgilendirme-formu?param',
      cache: true,
      async: true,
      beforeSend: function () { HC_Loading(true); },
      complete: function () { HC_Loading(false); },
      success: function (response) {
        var total = 0;
        var discount = 0;
        var subTotal = 0;
        var c = $.parseJSON(dec(localStorage.getItem('checkout')));
        var form = response;
        form = $(form).find('#ob-form').html()
          .replaceAll('{customerName}', getFromArr(c, 'checkout[shipping_address][first_name]') + ' ' + getFromArr(c, 'checkout[shipping_address][last_name]'))
          .replaceAll('{customerAddress}', getFromArr(c, 'checkout[shipping_address][address1]') + ' ' + getFromArr(c, 'checkout[shipping_address][city]') + ' ' + getFromArr(c, 'checkout[shipping_address][address2]'))
          .replaceAll('{email}', getFromArr(c, 'checkout[email]'))
          .replaceAll('{phone}', getFromArr(c, 'checkout[shipping_address][phone]'))
          .replaceAll('{fax}', '')
          .replaceAll('{cargoPrice}', $('.total-line.total-line--shipping td span').html())
          .replaceAll('{discountPrice}', '')
          .replaceAll('{totalPrice}', $('.total-line__price.payment-due span:eq(1)').html())
          .replaceAll('{paymentType}', '')
          .replaceAll('{shipmentAddress}', getFromArr(c, 'checkout[shipping_address][address1]') + ' ' + getFromArr(c, 'checkout[shipping_address][city]') + ' ' + getFromArr(c, 'checkout[shipping_address][address2]'))
          .replaceAll('{shipmentCustomerName}', getFromArr(c, 'checkout[shipping_address][first_name]') + ' ' + getFromArr(c, 'checkout[shipping_address][last_name]'))
          .replaceAll('{billingAddress}', getLocalStorage('checkout-billing_address-different') === false ? (getFromArr(c, 'checkout[shipping_address][address1]') + ' ' + getFromArr(c, 'checkout[shipping_address][city]') + ' ' + getFromArr(c, 'checkout[shipping_address][address2]')) : ($('#checkout_billing_address_address1').val() + ' ' + $('#checkout_billing_address_city').val() + ' ' + $('#checkout_billing_address_address2').val()))
          .replaceAll('{date}', new Date().getDate() + '.' + (new Date().getMonth() + 1) + '.' + new Date().getFullYear());
        
        if (form !== '') {
            var title = '<div class="hc-product-info-title"><h2>Ön Bilgilendirme Koşulları</h2></div>';
            var body = '<div class="hc-product-info-body" style="padding: 20px;overflow:scroll; max-height:600px;">' + form + '<div class="hc-clear"></div></div>';
            var close = '<div class="hc-product-info-close"><span onclick="HC_CloseInventoryInfo()">X</span></div>';
            var area = '<div class="hc-product-info-area hc-form-info">' + close + title + body + '</div>';
            var html = '<div class="hc-product-info-bg">' + area + '</div>';
            $('body').prepend(html);
          
            $('.order-summary__section__content table.product-table tbody[data-order-summary-section="line-items"] tr.product').each(function(i, v){
                var orderItem = $('.mss-form-order-item').eq(0).clone();
                orderItem.find('span:eq(0)').html((i + 1) + '.Ürün: ' + $(v).find('.product__description span:eq(0)').html() + ' ' + $(v).find('.product__description span:eq(1)').html());
                orderItem.find('span:eq(1)').html($(v).find('.product__quantity span:eq(0)').html());
                orderItem.find('span:eq(2)').html($(v).find('.product__price span:eq(0)').html());
                orderItem.find('span:eq(3)').html($(v).find('.product__price span:eq(0)').html());
                $('.mss-form-order-item').eq(i).after(orderItem);
            });
            $('.mss-form-order-item').eq(0).remove();
        }
      },
      error: function () { },
  });
}


function GetUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
    return false;
};

function setLocalStorage(key, value, ttl) {
    const now = new Date()

    const item = {
        value: value,
        expiry: now.getTime() + (ttl * 1000),
    }
    localStorage.setItem(key, JSON.stringify(item))
}

function getLocalStorage(key) {
    const itemStr = localStorage.getItem(key)
    if (!itemStr) {
        return null
    }
    const item = JSON.parse(itemStr)
    const now = new Date()
    if (now.getTime() > item.expiry) {
        localStorage.removeItem(key)
        return null
    }
    return item
}

function enc(t){
  return CryptoJS.AES.encrypt(t, key).toString();
}

function dec(t){
  var b = CryptoJS.AES.decrypt(t, key);
  t = b.toString(CryptoJS.enc.Utf8);
  return t; 
}

function getFromArr(arr, name) {
  if(arr === undefined || arr === null || name === '' || name === undefined) return '';
  return arr.find(z=>z.name === name && z.value !== '')?.value ?? '';
}

function mobileDevice() {
  var standalone = window.navigator.standalone,
    userAgent = window.navigator.userAgent.toLowerCase(),
    safari = /safari/.test( userAgent ),
    ios = /iphone|ipod|ipad/.test( userAgent ),
    android = /android/.test( userAgent );
    
  return (!standalone && !safari) || android;
  //return /iPad|iPhone|iPod|android/i.test(navigator.userAgent);
}




const cities = [
  "ADANA",
  "AFYONKARAHİSAR",
  "ANKARA",
  "ANTALYA",
  "AYDIN",
  "BALIKESİR",
  "BOLU",
  "BURSA",
  "ÇANAKKALE",
  "DENİZLİ",
  "DİYARBAKIR",
  "EDİRNE",
  "ESKİŞEHİR",
  "GAZİANTEP",
  "HATAY",
  "İSTANBUL",
  "İZMİR",
  "KAHRAMANMARAŞ",
  "KAYSERİ",
  "KOCAELİ",
  "KONYA",
  "MERSİN",
  "SAKARYA",
  "SAMSUN",
  "TEKİRDAĞ",
  "TRABZON",
  "VAN"
];
const cityjson = {
  "İstanbul": [
    "Adalar",
    "Arnavutköy",
    "Ataşehir",
    "Avcılar",
    "Bahçelievler",
    "Bakırköy",
    "Bayrampaşa",
    "Bağcılar",
    "Başakşehir",
    "Beykoz",
    "Beylikdüzü",
    "Beyoğlu",
    "Beşiktaş",
    "Büyükçekmece",
    "Esenler",
    "Esenyurt",
    "Eyüpsultan",
    "Fatih",
    "Gaziosmanpaşa",
    "Güngören",
    "Kadıköy",
    "Kartal",
    "Kağıthane",
    "Küçükçekmece",
    "Maltepe",
    "Pendik",
    "Sancaktepe",
    "Sarıyer",
    "Sultanbeyli",
    "Sultangazi",
    "Silivri",
    "Tuzla",
    "Zeytinburnu",
    "Çatalca",
    "Çekmeköy",
    "Ümraniye",
    "Üsküdar",
    "Şile",
    "Şişli"
  ],
  "Adana": [
    "Aladağ",
    "Ceyhan",
    "Feke",
    "Karataş",
    "Karaisalı",
    "Kozan",
    "Pozantı",
    "Sarıçam",
    "Saimbeyli",
    "Seyhan",
    "Tufanbeyli",
    "Yumurtalık",
    "Yüreğir",
    "Çukurova",
    "İmamoğlu"
  ],
  "Adıyaman": [
    "Besni",
    "Gerger",
    "Gölbaşı",
    "Kahta",
    "Merkez",
    "Samsat",
    "Sincik",
    "Tut",
    "Çelikhan"
  ],
  "Afyonkarahisar": [
    "Bayat",
    "Başmakçı",
    "Bolvadin",
    "Dinar",
    "Emirdağ",
    "Evciler",
    "Hocalar",
    "Kızılören",
    "Merkez",
    "Sandıklı",
    "Sultandağı",
    "Sinanpaşa",
    "Dazkırı",
    "Çay",
    "Çobanlar",
    "İhsaniye",
    "İscehisar",
    "Şuhut"
  ],
  "Aksaray": [
    "Ağaçören",
    "Eskil",
    "Gülağaç",
    "Güzelyurt",
    "Merkez",
    "Ortaköy",
    "Sultanhanı",
    "Sarıyahşi"
  ],
  "Amasya": [
    "Göynücek",
    "Gümüşhacıköy",
    "Hamamözü",
    "Merkez",
    "Merzifon",
    "Suluova",
    "Taşova"
  ],
  "Ankara": [
    "Akyurt",
    "Altındağ",
    "Ayaş",
    "Bala",
    "Beypazarı",
    "Elmadağ",
    "Etimesgut",
    "Evren",
    "Gölbaşı",
    "Güdül",
    "Haymana",
    "Kahramankazan",
    "Kalecik",
    "Keçiören",
    "Kızılcahamam",
    "Mamak",
    "Nallıhan",
    "Polatlı",
    "Pursaklar",
    "Sincan",
    "Yenimahalle",
    "Çamlıdere",
    "Çankaya",
    "Çubuk",
    "Şereflikoçhisar"
  ],
  "Antalya": [
    "Akseki",
    "Aksu",
    "Alanya",
    "Demre",
    "Döşemealtı",
    "Elmalı",
    "Finike",
    "Gazipaşa",
    "Gündoğmuş",
    "Kaş",
    "Kemer",
    "Kepez",
    "Konyaaltı",
    "Korkuteli",
    "Kumluca",
    "Manavgat",
    "Muratpaşa",
    "Serik",
    "İbradı"
  ],
  "Ardahan": [
    "Damal",
    "Göle",
    "Hanak",
    "Merkez",
    "Posof",
    "Çıldır"
  ],
  "Artvin": [
    "Ardanuç",
    "Arhavi",
    "Borçka",
    "Hopa",
    "Merkez",
    "Murgul",
    "Kemalpaşa",
    "Yusufeli",
    "Şavşat"
  ],
  "Aydın": [
    "Bozdoğan",
    "Buharkent",
    "Didim",
    "Efeler",
    "Germencik",
    "Karacasu",
    "Karpuzlu",
    "Koçarlı",
    "Kuyucak",
    "Kuşadası",
    "Köşk",
    "Nazilli",
    "Sultanhisar",
    "Söke",
    "Yenipazar",
    "Çine",
    "İncirliova"
  ],
  "Ağrı": [
    "Doğubayazıt",
    "Diyadin",
    "Eleşkirt",
    "Hamur",
    "Merkez",
    "Patnos",
    "Taşlıçay",
    "Tutak"
  ],
  "Aydın": [
    "Bozdoğan",
    "Buharkent",
    "Didim",
    "Efeler",
    "Germencik",
    "Karacasu",
    "Karpuzlu",
    "Koçarlı",
    "Kuyucak",
    "Kuşadası",
    "Köşk",
    "Merkez",
    "Nazilli",
    "Ortaklar",
    "Sultanhisar",
    "Söke",
    "Yenipazar",
    "Çine",
    "İncirliova"
  ],
  "Ağrı": [
    "Doğubayazıt",
    "Diyadin",
    "Eleşkirt",
    "Hamur",
    "Merkez",
    "Patnos",
    "Taşlıçay",
    "Tutak"
  ],
  "Balıkesir": [
    "Altıeylül",
    "Ayvalık",
    "Balya",
    "Bandırma",
    "Burhaniye",
    "Bigadiç",
    "Dursunbey",
    "Edremit",
    "Erdek",
    "Gömeç",
    "Gönen",
    "Havran",
    "Karesi",
    "Kepsut",
    "Manyas",
    "Marmara",
    "Savaştepe",
    "Sındırgı",
    "Susurluk",
    "İvrindi"
  ],
  "Bartın": [
    "Amasra", "Kurucaşile", "Merkez", "Ulus"
  ],
  "Batman": [
    "Beşiri",
    "Gercüş",
    "Hasankeyf",
    "Kozluk",
    "Merkez",
    "Sason"
  ],
  "Bayburt": [
    "Aydıntepe", "Demirözü", "Merkez"
  ],
  "Bilecik": [
    "Bozüyük",
    "Gölpazarı",
    "Merkez",
    "Osmaneli",
    "Pazaryeri",
    "Söğüt",
    "Yenipazar",
    "İnhisar"
  ],
  "Bingöl": [
    "Adaklı",
    "Genç",
    "Karlıova",
    "Kiğı",
    "Merkez",
    "Solhan",
    "Yayladere",
    "Yedisu"
  ],
  "Bitlis": [
    "Adilcevaz",
    "Ahlat",
    "Güroymak",
    "Hizan",
    "Merkez",
    "Mutki",
    "Tatvan"
  ],
  "Bolu": [
    "Dörtdivan",
    "Gerede",
    "Göynük",
    "Kıbrıscık",
    "Mengen",
    "Merkez",
    "Mudurnu",
    "Seben",
    "Yeniçağa"
  ],
  "Burdur": [
    "Altınyayla",
    "Ağlasun",
    "Bucak",
    "Gölhisar",
    "Karamanlı",
    "Kemer",
    "Merkez",
    "Tefenni",
    "Yeşilova",
    "Çavdır",
    "Çeltikçi"
  ],
  "Bursa": [
    "Büyükorhan",
    "Gemlik",
    "Gürsu",
    "Harmancık",
    "Karacabey",
    "Keles",
    "Kestel",
    "Mudanya",
    "Mustafakemalpaşa",
    "Nilüfer",
    "Orhaneli",
    "Orhangazi",
    "Osmangazi",
    "Yenişehir",
    "Yıldırım",
    "İnegöl",
    "İznik"
  ],
  "Çanakkale": [
    "Ayvacık",
    "Bayramiç",
    "Bozcaada",
    "Biga",
    "Eceabat",
    "Ezine",
    "Gelibolu",
    "Gökçeada",
    "Lapseki",
    "Merkez",
    "Yenice",
    "Çan"
  ],
  "Çankırı": [
    "Atkaracalar",
    "Bayramören",
    "Eldivan",
    "Ilgaz",
    "Kızılırmak",
    "Korgun",
    "Kurşunlu",
    "Merkez",
    "Orta",
    "Yapraklı",
    "Çerkeş",
    "Şabanözü"
  ],
  "Çorum": [
    "Alaca",
    "Bayat",
    "Boğazkale",
    "Dodurga",
    "Kargı",
    "Laçin",
    "Mecitözü",
    "Merkez",
    "Ortaköy",
    "Osmancık",
    "Oğuzlar",
    "Sungurlu",
    "Uğurludağ",
    "İskilip"
  ],
  "Denizli": [
    "Acıpayam",
    "Babadağ",
    "Baklan",
    "Bekilli",
    "Beyağaç",
    "Bozkurt",
    "Buldan",
    "Güney",
    "Honaz",
    "Kale",
    "Merkez",
    "Merkezefendi",
    "Pamukkale",
    "Sarayköy",
    "Serinhisar",
    "Tavas",
    "Çal",
    "Çameli",
    "Çardak",
    "Çivril"
  ],
  "Diyarbakır": [
    "Bağlar",
    "Bismil",
    "Dicle",
    "Ergani",
    "Eğil",
    "Hani",
    "Hazro",
    "Kayapınar",
    "Kocaköy",
    "Kulp",
    "Lice",
    "Sur",
    "Silvan",
    "Yenişehir",
    "Çermik",
    "Çınar",
    "Çüngüş"
  ],
  "Düzce": [
    "Akçakoca",
    "Cumayeri",
    "Gölyaka",
    "Gümüşova",
    "Kaynaşlı",
    "Merkez",
    "Yığılca",
    "Çilimli"
  ],
  "Edirne": [
    "Enez",
    "Havsa",
    "Keşan",
    "Lalapaşa",
    "Merkez",
    "Meriç",
    "Süloğlu",
    "Uzunköprü",
    "İpsala"
  ],
  "Elazığ": [
    "Alacakaya",
    "Arıcak",
    "Ağın",
    "Baskil",
    "Karakoçan",
    "Keban",
    "Kovancılar",
    "Maden",
    "Merkez",
    "Palu",
    "Sivrice"
  ],
  "Erzincan": [
    "Kemah",
    "Kemaliye",
    "Merkez",
    "Otlukbeli",
    "Refahiye",
    "Tercan",
    "Çayırlı",
    "Üzümlü",
    "İliç"
  ],
  "Erzurum": [
    "Aziziye",
    "Aşkale",
    "Hınıs",
    "Horasan",
    "Karayazı",
    "Karaçoban",
    "Köprüköy",
    "Narman",
    "Oltu",
    "Olur",
    "Palandöken",
    "Pasinler",
    "Pazaryolu",
    "Tekman",
    "Tortum",
    "Uzundere",
    "Yakutiye",
    "Çat",
    "İspir",
    "Şenkaya"
  ],
  "Eskişehir": [
    "Alpu",
    "Beylikova",
    "Günyüzü",
    "Han",
    "Mahmudiye",
    "Mihalgazi",
    "Mihalıcçık",
    "Odunpazarı",
    "Sarıcakaya",
    "Seyitgazi",
    "Sivrihisar",
    "Tepebaşı",
    "Çifteler",
    "İnönü"
  ],
  "Gaziantep": [
    "Araban",
    "Karkamış",
    "Nurdağı",
    "Nizip",
    "Oğuzeli",
    "Yavuzeli",
    "İslahiye",
    "Şahinbey",
    "Şehitkamil"
  ],
  "Giresun": [
    "Alucra",
    "Bulancak",
    "Dereli",
    "Doğankent",
    "Espiye",
    "Eynesil",
    "Görele",
    "Güce",
    "Keşap",
    "Merkez",
    "Piraziz",
    "Tirebolu",
    "Yağlıdere",
    "Çamoluk",
    "Çanakçı",
    "Şebinkarahisar"
  ],
  "Gümüşhane": [
    "Kelkit",
    "Köse",
    "Kürtün",
    "Merkez",
    "Torul",
    "Şiran"
  ],
  "Hakkari": [
    "Merkez",
    "Yüksekova",
    "Derecik",
    "Çukurca",
    "Şemdinli"
  ],
  "Hatay": [
    "Altınözü",
    "Antakya",
    "Arsuz",
    "Belen",
    "Defne",
    "Dörtyol",
    "Erzin",
    "Hassa",
    "Kırıkhan",
    "Kumlu",
    "Payas",
    "Reyhanlı",
    "Samandağ",
    "Yayladağı",
    "İskenderun"
  ],
  "Isparta": [
    "Aksu",
    "Atabey",
    "Eğirdir",
    "Gelendost",
    "Gönen",
    "Keçiborlu",
    "Merkez",
    "Senirkent",
    "Sütçüler",
    "Uluborlu",
    "Yalvaç",
    "Yenişarbademli",
    "Şarkikaraağaç"
  ],
  "Iğdır": [
    "Aralık", "Karakoyunlu", "Merkez", "Tuzluca"
  ],
  "İzmir": [
    "Aliağa",
    "Balçova",
    "Bayındır",
    "Bayraklı",
    "Bergama",
    "Beydağ",
    "Bornova",
    "Buca",
    "Dikili",
    "Foça",
    "Gaziemir",
    "Güzelbahçe",
    "Karabağlar",
    "Karaburun",
    "Karşıyaka",
    "Kemalpaşa",
    "Kınık",
    "Konak",
    "Kiraz",
    "Menderes",
    "Menemen",
    "Narlıdere",
    "Seferihisar",
    "Selçuk",
    "Torbalı",
    "Tire",
    "Urla",
    "Çeşme",
    "Çiğli",
    "Ödemiş"
  ],
  "Kahramanmaraş": [
    "Afşin",
    "Andırın",
    "Dulkadiroğlu",
    "Ekinözü",
    "Elbistan",
    "Göksun",
    "Onikişubat",
    "Nurhak",
    "Pazarcık",
    "Türkoğlu",
    "Çağlayancerit"
  ],
  "Karabük": [
    "Eflani",
    "Eskipazar",
    "Merkez",
    "Ovacık",
    "Safranbolu",
    "Yenice"
  ],
  "Karaman": [
    "Ayrancı",
    "Başyayla",
    "Ermenek",
    "Kazımkarabekir",
    "Merkez",
    "Sarıveliler"
  ],
  "Kars": [
    "Akyaka",
    "Arpaçay",
    "Digor",
    "Kağızman",
    "Merkez",
    "Sarıkamış",
    "Selim",
    "Susuz"
  ],
  "Kastamonu": [
    "Abana",
    "Araç",
    "Azdavay",
    "Ağlı",
    "Bozkurt",
    "Cide",
    "Daday",
    "Devrekani",
    "Doğanyurt",
    "Hanönü",
    "Küre",
    "Merkez",
    "Pınarbaşı",
    "Seydiler",
    "Taşköprü",
    "Tosya",
    "Çatalzeytin",
    "İhsangazi",
    "İnebolu",
    "Şenpazar"
  ],
  "Kayseri": [
    "Akkışla",
    "Bünyan",
    "Develi",
    "Felahiye",
    "Hacılar",
    "Kocasinan",
    "Melikgazi",
    "Pınarbaşı",
    "Sarıoğlan",
    "Sarız",
    "Talas",
    "Tomarza",
    "Yahyalı",
    "Yeşilhisar",
    "Özvatan",
    "İncesu"
  ],
  "Kırıkkale": [
    "Bahşili",
    "Balışeyh",
    "Delice",
    "Karakeçili",
    "Keskin",
    "Merkez",
    "Sulakyurt",
    "Yahşihan",
    "Çelebi"
  ],
  "Kırklareli": [
    "Babaeski",
    "Demirköy",
    "Kofçaz",
    "Lüleburgaz",
    "Merkez",
    "Pehlivanköy",
    "Pınarhisar",
    "Vize"
  ],
  "Kırşehir": [
    "Akpınar",
    "Akçakent",
    "Boztepe",
    "Kaman",
    "Merkez",
    "Mucur",
    "Çiçekdağı"
  ],
  "Kilis": [
    "Elbeyli", "Merkez", "Musabeyli", "Polateli"
  ],
  "Kocaeli": [
    "Başiskele",
    "Darıca",
    "Derince",
    "Dilovası",
    "Gebze",
    "Gölcük",
    "Kandıra",
    "Karamürsel",
    "Kartepe",
    "Körfez",
    "Çayırova",
    "İzmit"
  ],
  "Konya": [
    "Ahırlı",
    "Akören",
    "Akşehir",
    "Altınekin",
    "Beyşehir",
    "Bozkır",
    "Cihanbeyli",
    "Derbent",
    "Derebucak",
    "Doğanhisar",
    "Emirgazi",
    "Ereğli",
    "Güneysınır",
    "Hadim",
    "Halkapınar",
    "Hüyük",
    "Ilgın",
    "Kadınhanı",
    "Karapınar",
    "Karatay",
    "Kulu",
    "Meram",
    "Sarayönü",
    "Selçuklu",
    "Seydişehir",
    "Taşkent",
    "Tuzlukçu",
    "Yalıhüyük",
    "Yunak",
    "Çeltik",
    "Çumra"
  ],
  "Kütahya": [
    "Altıntaş",
    "Aslanapa",
    "Domaniç",
    "Dumlupınar",
    "Emet",
    "Gediz",
    "Hisarcık",
    "Merkez",
    "Pazarlar",
    "Simav",
    "Tavşanlı",
    "Çavdarhisar",
    "Şaphane"
  ],
  "Malatya": [
    "Akçadağ",
    "Arapgir",
    "Arguvan",
    "Battalgazi",
    "Darende",
    "Doğanyol",
    "Doğanşehir",
    "Hekimhan",
    "Kale",
    "Kuluncak",
    "Pütürge",
    "Yazıhan",
    "Yeşilyurt"
  ],
  "Manisa": [
    "Ahmetli",
    "Akhisar",
    "Alaşehir",
    "Demirci",
    "Gölmarmara",
    "Gördes",
    "Kırkağaç",
    "Kula",
    "Köprübaşı",
    "Salihli",
    "Sarıgöl",
    "Saruhanlı",
    "Selendi",
    "Soma",
    "Turgutlu",
    "Yunusemre",
    "Şehzadeler"
  ],
  "Mardin": [
    "Artuklu",
    "Dargeçit",
    "Derik",
    "Kızıltepe",
    "Mazıdağı",
    "Merkez",
    "Midyat",
    "Nusaybin",
    "Savur",
    "Yeşilli",
    "Ömerli"
  ],
  "Mersin": [
    "Akdeniz",
    "Anamur",
    "Aydıncık",
    "Bozyazı",
    "Erdemli",
    "Gülnar",
    "Mezitli",
    "Mut",
    "Silifke",
    "Tarsus",
    "Toroslar",
    "Yenişehir",
    "Çamlıyayla"
  ],
  "Muğla": [
    "Bodrum",
    "Dalaman",
    "Datça",
    "Fethiye",
    "Kavaklıdere",
    "Köyceğiz",
    "Marmaris",
    "Menteşe",
    "Merkez",
    "Milas",
    "Ortaca",
    "Seydikemer",
    "Ula",
    "Yatağan"
  ],
  "Muş": [
    "Bulanık",
    "Hasköy",
    "Korkut",
    "Malazgirt",
    "Merkez",
    "Varto"
  ],
  "Nevşehir": [
    "Acıgöl",
    "Avanos",
    "Derinkuyu",
    "Gülşehir",
    "Hacıbektaş",
    "Kozaklı",
    "Merkez",
    "Ürgüp"
  ],
  "Niğde": [
    "Altunhisar",
    "Bor",
    "Merkez",
    "Ulukışla",
    "Çamardı",
    "Çiftlik"
  ],
  "Ordu": [
    "Akkuş",
    "Altınordu",
    "Aybastı",
    "Fatsa",
    "Gölköy",
    "Gülyalı",
    "Gürgentepe",
    "Kabadüz",
    "Kabataş",
    "Korgan",
    "Kumru",
    "Mesudiye",
    "Perşembe",
    "Ulubey",
    "Çamaş",
    "Çatalpınar",
    "Çaybaşı",
    "Ünye",
    "İkizce"
  ],
  "Osmaniye": [
    "Bahçe",
    "Düziçi",
    "Hasanbeyli",
    "Kadirli",
    "Merkez",
    "Sumbas",
    "Toprakkale"
  ],
  "Rize": [
    "Ardeşen",
    "Derepazarı",
    "Fındıklı",
    "Güneysu",
    "Hemşin",
    "Kalkandere",
    "Merkez",
    "Pazar",
    "Çamlıhemşin",
    "Çayeli",
    "İkizdere",
    "İyidere"
  ],
  "Sakarya": [
    "Adapazarı",
    "Akyazı",
    "Arifiye",
    "Erenler",
    "Ferizli",
    "Geyve",
    "Hendek",
    "Karapürçek",
    "Karasu",
    "Kaynarca",
    "Kocaali",
    "Pamukova",
    "Sapanca",
    "Serdivan",
    "Söğütlü",
    "Taraklı"
  ],
  "Samsun": [
    "Ondokuzmayıs",
    "Alaçam",
    "Asarcık",
    "Atakum",
    "Ayvacık",
    "Bafra",
    "Canik",
    "Havza",
    "Kavak",
    "Ladik",
    "Salıpazarı",
    "Tekkeköy",
    "Terme",
    "Vezirköprü",
    "Yakakent",
    "Çarşamba",
    "İlkadım"
  ],
  "Siirt": [
    "Baykan",
    "Eruh",
    "Kurtalan",
    "Merkez",
    "Pervari",
    "Tillo",
    "Şirvan"
  ],
  "Sinop": [
    "Ayancık",
    "Boyabat",
    "Durağan",
    "Dikmen",
    "Erfelek",
    "Gerze",
    "Merkez",
    "Saraydüzü",
    "Türkeli"
  ],
  "Sivas": [
    "Akıncılar",
    "Altınyayla",
    "Doğanşar",
    "Divriği",
    "Gemerek",
    "Gölova",
    "Gürün",
    "Hafik",
    "Kangal",
    "Koyulhisar",
    "Merkez",
    "Suşehri",
    "Ulaş",
    "Yıldızeli",
    "Zara",
    "İmranlı",
    "Şarkışla"
  ],
  "Şanlıurfa": [
    "Akçakale",
    "Bozova",
    "Birecik",
    "Ceylanpınar",
    "Eyyübiye",
    "Halfeti",
    "Haliliye",
    "Harran",
    "Hilvan",
    "Karaköprü",
    "Merkez",
    "Suruç",
    "Siverek",
    "Viranşehir"
  ],
  "Şırnak": [
    "Beytüşşebap",
    "Cizre",
    "Güçlükonak",
    "Merkez",
    "Silopi",
    "Uludere",
    "İdil"
  ],
  "Tekirdağ": [
    "Ergene",
    "Hayrabolu",
    "Kapaklı",
    "Malkara",
    "Marmaraereğlisi",
    "Muratlı",
    "Saray",
    "Süleymanpaşa",
    "Çerkezköy",
    "Çorlu",
    "Şarköy"
  ],
  "Tokat": [
    "Almus",
    "Artova",
    "Başçiftlik",
    "Erbaa",
    "Merkez",
    "Niksar",
    "Pazar",
    "Reşadiye",
    "Sulusaray",
    "Turhal",
    "Yeşilyurt",
    "Zile"
  ],
  "Trabzon": [
    "Akçaabat",
    "Araklı",
    "Arsin",
    "Beşikdüzü",
    "Dernekpazarı",
    "Düzköy",
    "Hayrat",
    "Köprübaşı",
    "Maçka",
    "Of",
    "Ortahisar",
    "Sürmene",
    "Tonya",
    "Vakfıkebir",
    "Yeşilyurt",
    "Yomra",
    "Çarşıbaşı",
    "Çaykara",
    "Şalpazarı"
  ],
  "Tunceli": [
    "Hozat",
    "Mazgirt",
    "Merkez",
    "Nazımiye",
    "Ovacık",
    "Pertek",
    "Pülümür",
    "Çemişgezek"
  ],
  "Uşak": [
    "Banaz",
    "Eşme",
    "Karahallı",
    "Merkez",
    "Sivaslı",
    "Ulubey"
  ],
  "Van": [
    "Bahçesaray",
    "Başkale",
    "Edremit",
    "Erciş",
    "Gevaş",
    "Gürpınar",
    "Merkez",
    "Muradiye",
    "Saray",
    "Tuşba",
    "Çaldıran",
    "Çatak",
    "Özalp",
    "İpekyolu"
  ],
  "Yalova": [
    "Altınova",
    "Armutlu",
    "Merkez",
    "Termal",
    "Çınarcık",
    "Çiftlikköy"
  ],
  "Yozgat": [
    "Akdağmadeni",
    "Aydıncık",
    "Boğazlıyan",
    "Kadışehri",
    "Merkez",
    "Saraykent",
    "Sarıkaya",
    "Sorgun",
    "Yenifakılı",
    "Yerköy",
    "Çandır",
    "Çayıralan",
    "Çekerek",
    "Şefaatli"
  ],
  "Zonguldak": [
    "Alaplı",
    "Devrek",
    "Ereğli",
    "Gökçebey",
    "Kozlu",
    "Kilimli",
    "Merkez",
    "Çaycuma"
  ]
};
const storesByCity = {
  "ADANA": [
    "M014", "M080"
  ],
  "AFYONKARAHİSAR": ["M071"],
  "ANKARA": [
    "M141",
    "M152",
    "M037",
    "M023",
    "M049",
    "M048",
    "M062",
    "M092",
    "M019"
  ],
  "ANTALYA": [
    "M115",
    "M066",
    "M026",
    "M147",
    "M106",
    "M083"
  ],
  "AYDIN": [
    "M145", "M096"
  ],
  "BALIKESİR": [
    "M148", "M027"
  ],
  "BOLU": ["M087"],
  "BURSA": [
    "M155", "M164", "M067"
  ],
  "ÇANAKKALE": ["M125"],
  "DENİZLİ": ["M081"],
  "DİYARBAKIR": ["M127"],
  "EDİRNE": ["M044"],
  "ESKİŞEHİR": [
    "M100", "M043"
  ],
  "GAZİANTEP": [
    "M149", "M108"
  ],
  "HATAY": [
    "M073", "M113"
  ],
  "İSTANBUL": [
    "M068",
    "M079",
    "M008",
    "M045",
    "M171",
    "M132",
    "M038",
    "M030",
    "M121",
    "M012",
    "M140",
    "M153",
    "M034",
    "M104",
    "M058",
    "M116",
    "M097",
    "M077",
    "M065",
    "M069",
    "M015",
    "M016",
    "M159",
    "M161",
    "M130",
    "M061",
    "M063",
    "M120",
    "M093",
    "M024",
    "M076"
  ],
  "İZMİR": [
    "M031",
    "M022",
    "M163",
    "M136",
    "M165",
    "M095"
  ],
  "KAHRAMANMARAŞ": ["M102"],
  "KAYSERİ": [
    "M170", "M090"
  ],
  "KOCAELİ": [
    "M129", "M018"
  ],
  "KONYA": ["M088"],
  "MERSİN": ["M042"],
  "SAKARYA": ["M133"],
  "SAMSUN": [
    "M094", "M101"
  ],
  "TEKİRDAĞ": ["M028"],
  "TRABZON": ["M056"],
  "VAN": ["M143"]
};
const storeMappings = {
  "M014": "ADANA REAL",
  "M080": "ADANA OPTIMUM",
  "M071": "AFYON IKBAL",
  "M141": "GORDION",
  "M152": "KENTPARK",
  "M037": "CEPA",
  "M023": "ANKAMALL",
  "M049": "ACITY",
  "M048": "ANTARES",
  "M062": "ETLIK FORUM",
  "M092": "ANKARA NATA",
  "M019": "ERYAMAN OPTIMUM",
  "M147": "MANAVGAT NOVADA",
  "M115": "ANTALYA DEEPO",
  "M066": "ANTALYA OZDILEK",
  "M026": "ANTALYA MIGROS",
  "M083": "TERRACITY",
  "M106": "MARKANTALYA",
  "M096": "SOKE NOVADA",
  "M145": "AYDIN FORUM",
  "M148": "EDREMIT NOVADA",
  "M027": "SUSURLUK",
  "M087": "BOLU HIGHWAY",
  "M155": "BURSA MARKA",
  "M164": "BURSA KORUPARK",
  "M067": "BURSA ASMERKEZ",
  "M125": "ÇANAKKALE 17",
  "M081": "DENIZLI FORUM",
  "M127": "DIYARBAKIR FORUM",
  "M044": "EDIRNE MARGI",
  "M100": "ESKISEHIR VEGA OUTLET",
  "M043": "ESKISEHIR ESPARK",
  "M149": "SANKOPARK GAZIANTEP",
  "M108": "GAZIANTEP PRIMEMALL",
  "M073": "ISKENDERUN PRIMEMALL",
  "M113": "ANTAKYA PALLADIUM",
  "M068": "AIRPORT",
  "M079": "MARMARA FORUM",
  "M008": "CAROUSEL",
  "M045": "CAPACITY",
  "M171": "LALELI",
  "M132": "VIAPORT VENEZIA",
  "M038": "ISTINYEPARK",
  "M030": "CEVAHIR",
  "M121": "OZDILEKPARK ISTANBUL",
  "M012": "CAPITOL",
  "M140": "AKASYA",
  "M153": "EMAAR",
  "M034": "OLIVIUM",
  "M104": "AXIS KAGITHANE",
  "M058": "VIAPORT",
  "M116": "CANPARK",
  "M097": "ISTANBUL FORUM",
  "M077": "PELICAN",
  "M065": "212 POWER",
  "M069": "STARCITY",
  "M015": "MALTEPE",
  "M016": "CEVIZLI MALTEPEPARK",
  "M159": "KUCUKYALI HILLTOWN",
  "M161": "MALTEPE PIAZZA",
  "M130": "TUZLA VIAPORT MARINE",
  "M061": "PALLADIUM",
  "M063": "KADIKOY OPTIMUM",
  "M120": "MALL OF ISTANBUL",
  "M093": "MARMARAPARK",
  "M024": "BEYLIKDUZU MIGROS",
  "M076": "TORIUM",
  "M031": "BORNOVA FORUM",
  "M163": "KARSIYAKA HILLTOWN",
  "M136": "MAVIBAHCE",
  "M022": "BALCOVA",
  "M165": "IZMIR ISTINYEPARK",
  "M095": "IZMIR OPTIMUM",
  "M102": "MARAS PIAZZA",
  "M170": "KAYSERI PARK",
  "M090": "KAYSERI FORUM",
  "M129": "KOCAELI 41",
  "M018": "IZMIT",
  "M088": "KONYA",
  "M042": "MERSIN FORUM",
  "M133": "ADAPAZARI SERDIVAN",
  "M094": "SAMSUN LOVELET",
  "M101": "SAMSUN PIAZZA",
  "M028": "CORLU ORION",
  "M056": "TRABZON FORUM",
  "M143": "VAN"
};

  } // End of initCustomScripts function

  // Wait for jQuery to be available
  if (typeof jQuery !== 'undefined') {
    initCustomScripts();
  } else {
    // jQuery not yet loaded, wait for it
    var jQueryCheck = setInterval(function() {
      if (typeof jQuery !== 'undefined') {
        clearInterval(jQueryCheck);
        initCustomScripts();
      }
    }, 50);
  }
})();

function getJsonFromApiBridge(response){
  if(response.success && response.data.body){
    return JSON.parse(response.data.body);
  }
  return null;
}